<template>
  <Viewer class="exercise-detail" :isOpenBookCats="openBookCats" :valOpenSidebar="typeOpenSidebar"
    :linkBack="{ name: 'exercise', query: { lop: routerParams.classId, tab: routerParams.practiceType } }"
    :hasLimit="!dataPractice || !dataPractice.actived || (authInfo && authInfo.email === emailPublic)">
    <template v-if="dataPractice" v-slot:viewer_head_name>{{ dataPractice.bookName }}</template>
    <template v-if="dataPractice" v-slot:viewer_head_right>
      <span v-if="screenWidth > 991" class="secondary-color-txt font-sanpro-light font-size-14 version">{{ versionApp
      }}</span>
      <!-- <div v-if="screenWidth < 992" class="cursor-pointer" @click="resetAnswers">
          <i class="icon-reset font-size-22 secondary-color-txt "></i>
      </div> -->
      <!-- <i class="icon-question font-size-20" @click="openModalNotiError"></i> -->
    </template>
    <template v-slot:viewr_body>
      <div class="exercise-detail__questions position-rel" v-if="screenWidth > 991">
        <div class="exercise-detail__list">
          <div class="item position-rel content-1">
            <div class="question-group" v-if="question && question.type && question.type === typeGroup">
              <PreviewQuestion :dataSource="question" :questions="[question]" :location="0" :preview="true"
                :questionsData="question" @formatQuestion="getInfoQuestion" @answerMissing="handleAnswerMissing" />
              <div class="questions-child" v-if="question.listQuestionChild">
                <div class="questions-child__item" v-for="(child, pos) of question.listQuestionChild" :key="pos">
                  <PreviewQuestion v-if="child" :dataSource="child" :location="pos" :parentIndex="0"
                    :isQuestionChild="true" :preview="true" :questionsData="question"
                    @formatQuestion="getInfoQuestion" />
                </div>
              </div>
              <p v-if="txtMissingQuestionGroup" class="question-missing-answer color-err">{{ txtMissingQuestionGroup }}
              </p>
            </div>
            <div class="question-single" v-else-if="question">
              <PreviewQuestion :dataSource="question" :location="0" :preview="true" @formatQuestion="getInfoQuestion"
                @answerMissing="handleAnswerMissing" />
            </div>
          </div>
        </div>

        <!-- Fix bug 37: Người dùng chỉ được xem lời giải chi tiết sau khi đã làm bài và nộp bài (ấn nút kiểm tra). Hiện đang cho xem ngay cả khi chưa làm bài
              Modified: anhdd (16/08/2022)
              Description: Thêm điều kiện question.isWorked
         -->
        <ExerciseGuide v-if="question && question.isWorked && sliderQuestionList && Object.keys(question).length > 0" :question="question"
          :handleShowGuide="showGuideContent" />
      </div>
      <div v-else class="exercise-detail__questions position-rel">
        <ExerciseQuestionDetail :question="question" :txtMissingQuestionGroup="txtMissingQuestionGroup"
          @answerMissing="handleAnswerMissing" />
      </div>
      <p v-if="booksOfExercise.length === 0" class="secondary-color-txt font-size-18 text-center pt-20">Dữ liệu đang cập
        nhật</p>
    </template>
    <!-- <template v-slot:viewer_sidebar_icon>
      <a href="javascript:;" :class="{'active': keySidebarActive === 'media'}" @click="openSidebar('media')" class="total-a"  data-toggle="tooltip" data-placement="left" title="Học liệu">
        <span class="icon-medias font-size-24"><span class="path1"></span><span class="path2"></span></span>
      </a>
      <a href="javascript:;" :class="{'active': keySidebarActive === 'link'}" @click="openSidebar('link')"><i class="icon-link font-size-24"></i></a>
      <a href="javascript:;" :class="{'active': keySidebarActive === 'info'}" @click="openSidebar('info')" class="total-a"  data-toggle="tooltip" data-placement="left" title="Thông tin">
        <i class="icon-info"></i>
      </a>
    </template> -->
    <!-- <template v-slot:viewer_sidebar_content>
      <ExerciseSidebar :keySidebarActive="keySidebarActive" :ebooksDetail="dataPractice" :checkQuestionId="questionIdCheckAnswer" :pageCurr="pagesOfQuestion" :mediaRelate="mediaRelate" />
    </template> -->
    <template v-slot:viewer_toggle_cat_name>Danh sách</template>
    <template v-slot:viewer_footer_center>
      <SliderNameQuestion v-if="sliderQuestionList && sliderQuestionList.length > 0" class="exercise-detail__swiper"
        :dataSource="sliderQuestionList" @handleNextCat="nextCatBook" @handlePrevCat="prevCatBook" />
    </template>
    <template v-slot:viewer_footer_mobile>
      <a href="javascript:;"
        class="font-size-16 font-sanpro-semibold display-block width-percentage-80 margin-center border-rd-20 text-center primary-bg-color mb-2"
        style="padding: 5px 0px">
        <span v-if="question && !question.isWorked" @click="checkAnswer" class="light-color">
          {{ question.type === typeDownAnswer ? 'Lưu đáp án' : 'Kiểm tra' }}
        </span>
        <span v-else-if="question && question.isWorked" class="light-color" @click="resetAnswers">Làm lại</span>
      </a>
    </template>
    <template v-slot:viewer_footer_right>
      <a v-if="question && !question.isWorked" href="javascript:;"
        class="btn btn-main font-size-16 font-sanpro-semibold border-rd-20 line-height-1-1 btn-min-w-120 btn-min-w-mb"
        :class="{ 'disabled': question && (question.type === typeDrawShape || questionindexActive === 0 || question.isWorked || question.statusWorked) }"
        @click="checkAnswer">
        <span class="check--text">
          {{ question.type === typeDownAnswer ? 'Lưu đáp án' : 'Kiểm tra' }}
        </span>
        <span class="check--icon"><i class="icon-save font-size-26"></i></span>
      </a>
      <a v-else-if="question && question.isWorked" href="javascript:;"
        class="btn btn-main font-size-16 font-sanpro-semibold border-rd-20 line-height-1-1 btn-min-w-120 btn-min-w-mb"
        @click="resetAnswers">
        <span class="check-text">Làm lại</span>
        <span class="check--icon"><i class="icon-reset primary-color font-size-26"></i></span>
      </a>
    </template>

    <template v-slot:viewer_sidebar_cat_head>
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold">
        Mục lục
      </h2>
      <div class="display-flex">
        <div class="book-viewer__cats__books content-left">
          <a v-for="(item, index) of booksOfExercise" href="javascript:;"
            class="btn font-size-14 border-rd-20 font-sanpro-semibold text-a"
            :class="{ 'btn-2 primary-color': bookId === item.bookId, 'primary-color-txt': bookId !== item.bookId }"
            @click="handleViewQuestionBook(item)" :key="index" v-show="item.practiveName || item.name">
            <span class="book--name">{{ item.practiveName ? item.practiveName : item.name }}</span>
          </a>
        </div>
        <div class="btn-active-book content-right">
          <i class="icon-key primary-color font-size-16 cursor-pointer" title="Kích hoạt sách" @click="handleActiveBook"></i>
        </div>
      </div>
      <div class="book-viewer__cats__activecode secondary-color-txt"
        v-if="booksOfExercise.length > 0 && (!dataPractice || !dataPractice.actived || (authInfo && authInfo.email === emailPublic))">
        <p v-if="authInfo && authInfo.email === emailPublic">Đăng ký / đăng nhập để sử dụng đầy đủ tính năng của Hành
          trang số.</p>
        <p v-if="authInfo && !isContainsEmailUnlimited(authInfo.email)">Kích hoạt mã cào sau mỗi cuốn sách giáo khoa để mở miễn phí học liệu điện tử và toàn bộ tính năng hỗ trợ</p>
        <!-- <a href="javascript:;" class="btn btn-2 font-size-16 border-rd-20 font-sanpro-semibold" @click="handleActiveBook">Kích hoạt</a> -->
      </div>
    </template>
    <template v-slot:viewer_sidebar_cat_body>
      <div class="book-viewer__cats__list exercise-detail__cats__list">
        <b-card v-for="(item, index) in exerciseCats" :key="index" class="card-item" :id="`cat_row_${item.bookIndexId}`"
          :class="{ 'active': collapseOpen === `cat_${item.bookIndexId}` }" no-body>
          <div class="card-wrap display-block">
            <b-card-header header-tag="header" role="tab" class="p-0 bg-transparent">
              <div class="cat-head display-flex justify-content-md-between full-width"
                :class="{ 'active': collapseOpen === `cat_${item.bookIndexId}` || catCurrent && ((catCurrent.bookIndexId === item.bookIndexId) || (!catCurrent.catParentFirst && catCurrent.catParent === item.bookIndexId)) }">
                <!-- :id="`cat_row_${item.bookIndexId}`" -->
                <span class="margin-0 font-size-16" :class="`
                  ${(dataPractice && item.pageNo <= dataPractice.limitPracticeX && !dataPractice.actived) || (dataPractice && item.pageNo <= dataPractice.limitPracticeY && dataPractice.actived) || isContainsEmailUnlimited(authInfo.email) ? 'primary-color' : 'secondary-color-txt'} 
                  ${collapseOpen === `cat_${item.bookIndexId}` || catCurrent && ((catCurrent.bookIndexId === item.bookIndexId) || (!catCurrent.catParentFirst && catCurrent.catParent === item.bookIndexId)) ? 'font-sanpro-semibold' : ''}
                `" @click="openCollapse(`cat_${item.bookIndexId}`, item)">
                  <!-- :class="{'actived': dataPractice && item.pageNo < dataPractice.limitPracticeY && dataPractice.actived,
                          'activeUnLogin': authInfo && authInfo.email === emailPublic && item.pageNo < dataPractice.limitPracticeX 
                          }" -->
                  {{ item.title }}
                  <span class="cat-space-title" v-if="item.title">:</span>
                  {{ item.name }}
                </span>
                <DropdownCat v-if="item.bookIndexId === parseInt($route.query.danhmuc)" :dataSource="item"
                  @resetQuestions="$bvModal.show(idModalConfirmDelQuestion)" />
              </div>
            </b-card-header>
            <b-collapse v-if="item.bookIndexChilds.length > 0" :id="`cat_${item.bookIndexId}`" accordion="my-accordion"
              role="tabpanel">
              <b-card-body>
                <ul class="cat-child margin-0 p-0">
                  <li class="d-block" v-for="(child, pos) of item.bookIndexChilds" :id="`cat_row_${child.bookIndexId}`"
                    :key="pos">
                    <a href="javascript:;" class="font-size-16 display-flex justify-content-between full-width" :class="`
                      ${(dataPractice && item.pageNo <= dataPractice.limitPracticeX && !dataPractice.actived) || (dataPractice && item.pageNo <= dataPractice.limitPracticeY && dataPractice.actived) || isContainsEmailUnlimited(authInfo.email)  ? 'primary-color' : 'secondary-color-txt'} 
                      ${catCurrent && ((catCurrent.bookIndexId === child.bookIndexId) || (catCurrent.catParentFirst && catCurrent.catParent === child.bookIndexId)) ? 'font-sanpro-semibold' : ''}
                    `">
                      <span @click="openCollapse(`cat_child_${child.bookIndexId}`, child)">
                        {{ child.title }}
                        <span class="cat-space-title" v-if="child.title">:</span>
                        {{ child.name }}
                      </span>
                      <DropdownCat v-if="child.bookIndexId === parseInt($route.query.danhmuc)"
                        :dataSource="{ ...child, parent: item }"
                        @resetQuestions="$bvModal.show(idModalConfirmDelQuestion)" />
                    </a>
                    <b-collapse v-if="child.bookIndexChilds.length > 0" :id="`cat_child_${child.bookIndexId}`"
                      accordion="my-accordion-child" role="tabpanelchild">
                      <b-card-body>
                        <ul class="cat-child margin-0 p-0">
                          <li v-for="(child2, loc) of child.bookIndexChilds" :id="`cat_row_${child2.bookIndexId}`"
                            :key="loc">
                            <a href="javascript:;" class="font-size-16 display-flex justify-content-between full-width"
                              :class="`
                                ${(dataPractice && item.pageNo <= dataPractice.limitPracticeX && !dataPractice.actived) || (dataPractice && item.pageNo <= dataPractice.limitPracticeY && dataPractice.actived) || isContainsEmailUnlimited(authInfo.email) ? 'primary-color' : 'secondary-color-txt'} 
                                ${catCurrent && catCurrent.bookIndexId === child2.bookIndexId ? 'font-sanpro-semibold' : ''}
                              `">
                              <!-- @click="getQuestions(child2.bookIndexId, child2, true)" -->
                              <!-- :class="{'active': catCurrent && catCurrent.bookIndexId === child2.bookIndexId}" -->
                              <span @click="replaceRouter(child2.bookIndexId,1,true)">
                                {{ child2.title }}
                                <span class="cat-space-title" v-if="child2.title">:</span>
                                {{ child2.name }}
                              </span>
                              <DropdownCat v-if="child2.bookIndexId === parseInt($route.query.danhmuc)"
                                :dataSource="{ ...child2, parent: child, grand: item }"
                                @resetQuestions="$bvModal.show(idModalConfirmDelQuestion)" />
                            </a>
                          </li>
                        </ul>
                      </b-card-body>
                    </b-collapse>
                  </li>
                </ul>
              </b-card-body>
            </b-collapse>
          </div>
        </b-card>
      </div>
    </template>
    <template v-slot:viewer_footer>
      <VituralKeyboard
        v-if="valVituralKeyboard && valVituralKeyboard.location > -1 && screenWidth > 991 && dataPractice.classId === idClass1 && dataPractice.subjectId === idMathSubject"
        :class="{ 'open-cat': openBookCats, 'over-height': valVituralKeyboard && valVituralKeyboard.isOverHaflScreen }"
        :style="`top: ${valVituralKeyboard.top}px; left: ${valVituralKeyboard.left}px`" />
      <audio v-if="actionPlayQuestionTrue" id="question_true" :src="correct" autoplay></audio>
      <audio v-if="actionPlayQuestionFalse" id="question_false" :src="incorrect" autoplay></audio>
      <div class="show-document" v-if="visiblePreviewSliderModal">
        <div class="inner-content js-model active">
          <ModalMedia @viewMoreMedia="viewMoreMedia" />
          <div class="js-background-model active" @click="handleOffModal"></div>
        </div>
      </div>
      <ModalPreviewExercise v-if="infoQuestionPreview && Object.keys(infoQuestionPreview).length > 0" />
      <b-modal :id="idModalConfirmDelQuestion" hide-header hide-footer>
        <div class="modal-confirm border-rd-10 text-center">
          <p>Bạn chắc chắn muốn làm lại tất cả bài tập?</p>
          <div class="modal-confirm__action text-center">
            <b-button variant="danger" class="font-size-16 line-height-1" @click="$bvModal.hide('modal_confirm_reset')">
              Hủy</b-button>
            <b-button variant="success" class="font-size-16 line-height-1" @click="resetQuestionsList()">Làm lại
            </b-button>
          </div>
        </div>
      </b-modal>
    </template>
  </Viewer>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question/_store/constants'
import { STORE_KEY, LOCAL_SAVE_CAT, LOCAL_SAVE_BREADCRUMB_CAT, LOCAL_SAVE_EXERCISE_CLASS, LOCAL_QUESTIONS_DATA, LOCAL_SAVE_QUESTIONS_WORKED, LOCAL_SAVE_CURRENT_QUESTIONS } from "./../_store/constants";
import { getCategoriesByBook, getQuestionsByCat, getInfoBookBasic, getQuestionsSidebar, getQuestionDetail, saveUserWorkQuestion, resetResultWorkQuestion, resetUserWorkQuestionByBookIndexId, getCatInfoOfExercise } from './../_api/';
import { getBooksByPractice } from './../_api/exercise-list';
import { scrollTo, callTimeDiff } from '@/helpers/functions';
import { EMAIL_PUBLIC, EMAIL_UNLIMITED } from '@/store/auth/constants'
import { ID_CLASS_1, ID_MATH_SUBJECT } from '@/store/common/constants'
import { getAuth } from '@/utils/jwt'
import mixinExercise from './../_store/mixinExercise'
// import { getEBooksDetail } from '@/modules/ebooks/_api'
import VituralKeyboard from '@/modules/question/preview-question/VituralKeyboard.vue'
import ExerciseSidebar from './../_components/ExerciseSidebar.vue'
import ModalMedia from '@/modules/ebooks/_components/ebook-viewer/ModalMedia.vue'
import SliderNameQuestion from './../_components/SliderNameQuestion.vue'
import PreviewQuestion from '@/modules/question/preview-question/PreviewQuestion.vue'
import ExerciseQuestionDetail from '@/modules/exercises/_views/ExerciseQuestionDetail.vue'
import DropdownCat from './.../../../_components/DropdownCat.vue'
import ModalPreviewExercise from './../_components/modal/ModalPreviewExercise.vue'
import { setContentMediaEditorShow } from '@/modules/question/preview-question/_store/helperQuestionContent'
import { COOKIE_AUTH } from '@/store/auth/constants';
import Cookies from 'js-cookie';
const correct = require('@/assets/audio/correct.mp3')
const incorrect = require('@/assets/audio/incorrect.mp3')

export default {
  name: 'ExerciseDetail',
  mixins: [mixinExercise],
  components: {
    vueCustomScrollbar,
    ExerciseQuestionList: () => import('./../_components/ExerciseQuestionList.vue'),
    ActiveCode: () => import('@/modules/ebooks/_components/common/ActiveCode.vue'),
    ExerciseGuide: () => import('./../_components/ExerciseGuide.vue'),
    Viewer: () => import('@/layouts/Viewer.vue'),
    ExerciseSidebar,
    ModalMedia,
    SliderNameQuestion,
    PreviewQuestion,
    VituralKeyboard,
    DropdownCat,
    ModalPreviewExercise,
    ExerciseQuestionDetail
  },
  data() {
    return {
      typeGroup: TYPE_GROUP,
      typeDrawShape: TYPE_DRAW_SHAPE_ANSWER,
      typeDownAnswer: TYPE_DOWN_ANSWER,
      typefillBlank: TYPE_FILL_BLANK,
      typeSelect: TYPE_SELECT,
      typeMatchCol: TYPE_MATH_COL,
      openBookCats: true,
      collapseOpen: '',
      settingsViewBookSidebar: {
        maxScrollbarLength: 300
      },
      exerciseCats: [],
      bookInfo: {},
      question: {},
      questions: [],
      questionindexActive: 0,
      catCurrent: null,
      nameSubject: '',
      nameTite: "",
      click: 1,
      classId: 0,
      subjectId: 0,
      catName: '',
      dataPractice: null,
      // bookCurrSaved: null,
      catsFlat: [],
      catsLength: 0,
      firstloadData: true,
      breadcrumbCurr: [],
      authInfo: {},
      emailPublic: EMAIL_PUBLIC,
      pageCurr: 0,
      nameRoute: this.$route.name,
      isShowVideo: 2,
      typeOpenSidebar: {},
      showGuideContent: false,
      pagesOfQuestion: [],
      mediaRelate: {},
      keySidebarActive: '',
      correct,
      incorrect,
      actionPlayQuestionTrue: false,
      actionPlayQuestionFalse: false,
      sliderQuestionList: [],
      typeGroup: TYPE_GROUP,
      errorTypeId: 2,
      handleNextPrevCat: '', //next or prev
      txtMissingQuestionGroup: '',
      questionIdCheckAnswer: {},
      idModalConfirmDelQuestion: 'modal_confirm_reset',
      idClass1: ID_CLASS_1,
      idMathSubject: ID_MATH_SUBJECT,
      startTimeQuestion: 0,
      bookId: 0,
      booksOfExercise: [],
      pageChange: 0,
      firstSetCurrentDetail: true,
      emailUnlimited: EMAIL_UNLIMITED
      // countQuestion: 0
    };
  },
  computed: {
    // bookId () {
    //   return this.$router.history.current.params.id;
    // },
    // bookIndexId() {
    //   return this.$router;
    // },
    routerParams() {
      return this.$route.params
    },
    screenWidth() {
      return window.innerWidth;
    },
    ...mapState('auth', ['loginPopupData']),
    ...mapState('common', ['idBookActiveSuccess', 'setRouterHelp', 'versionApp', 'visiblePreviewSliderModal']),
    ...mapState(STORE_KEY_QUESTION, ['valVituralKeyboard']),
    ...mapState(STORE_KEY, ['infoQuestionPreview'])
  },
  watch: {
    // pageChange(newVal){
    //   console.log('newewew', newVal);
    //   this.actionCheckPage(newVal)
    // },
    loginPopupData(newVal) {
      if (newVal && Object.keys(newVal).length) {
        this.authInfo = newVal;
        // this.getBookInfo();
        // if( !this.dataPractice.actived ) {
        //     this.$bvModal.show('modal_active_book');
        // }
      }
    },
    idBookActiveSuccess(newVal) {
      if (parseInt(newVal) === this.dataPractice.bookId) {
        this.handleActiveBookSuccess()
      }
    },
    valVituralKeyboard(newVal) {
      if (newVal.ref) {
        document.getElementById(newVal.ref).value = newVal.val;
        document.getElementById(newVal.ref).focus();
      }
    },
    '$route.query.danhmuc': 'handleRouterReplace',
    '$route.query.cauhoi': 'handleChangeQuestionDisplay',
  },
  created() {
    Promise.all([this.actionCheckRouterHelp({ nameRoute: this.nameRoute }), this.fetchBooksForExercise()])
    this.authInfo = getAuth();
    this.setVituralKeyVal({})
  },
  mounted() {
    this.startTimeQuestion = new Date()
  },
  beforeDestroy() {
    localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
  },
  methods: {
    ...mapActions('common', ['setLoading', 'setToggleModalActivePage', 'acSetDataBookActiveWant', 'acToggleModalActiveBook', 'acToggleModaShowHelp', 'actionCheckRouterHelp', 'actionGetVideoHelp', 'acToggleModaShowError', 'actionSetBookIndexId', 'actionSetBookIdForError', 'setActionCheckQuestion', 'actionSetPageNoBook', 'actionCheckExcercise', 'actionCheckInfoExcercise', 'actionCheckPage']),
    ...mapActions('auth', ['setToggleLoginForm']),
    ...mapActions(STORE_KEY, ['actionBookIndexOfBook']),
    ...mapActions(STORE_KEY_QUESTION, ['setVituralKeyVal', 'setQuestionData4CheckAnswer', 'setQuestionList4CheckAnswer']),
    isContainsEmailUnlimited(email){
      let listEmailUnlimited = this.emailUnlimited.split(',')
      return listEmailUnlimited.indexOf(email) > -1
    },
    fetchBooksForExercise() {
      const { classId, subjectId } = this.routerParams
      let payload = {
        classId,
        subjectId,
        bookTypeId: parseInt(this.routerParams.bookType),
        practiceTypeId: parseInt(this.routerParams.practiceType)
      }
      getBooksByPractice(payload).then(res => {
        if (res && res.length > 0) {
          this.booksOfExercise = res
          this.bookId = res[0].bookId
          this.$router.replace({ query: { sach: res[0].bookId } })
          Promise.all([this.getSubjects(), this.getBookInfo()])
        } else {
          this.openBookCats = false
        }
      })
    },

    async handleViewQuestionBook(data) {
      this.firstSetCurrentDetail = true
      this.question = {}
      this.questions = []
      this.bookId = data.bookId
      this.dataPractice = null
      await this.$router.replace({ query: { sach: data.bookId, danhmuc: 0, cauhoi: 0 } })
      await localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
      await localStorage.removeItem(LOCAL_SAVE_CAT)
      await localStorage.removeItem(LOCAL_SAVE_EXERCISE_CLASS)
      await localStorage.removeItem(LOCAL_QUESTIONS_DATA)

      Promise.all([this.getBookInfo(), this.getSubjects()])
    },

    openModalNotiError() {
      this.actionGetVideoHelp({ isShowVideo: this.isShowVideo })
      this.acToggleModaShowHelp(true)
    },

    getInfoPracticeSaved() {
      let dataPracticeSaved = localStorage.getItem(LOCAL_SAVE_EXERCISE_CLASS);
      if (dataPracticeSaved && dataPracticeSaved !== null && dataPracticeSaved !== undefined) {
        this.dataPractice = JSON.parse(dataPracticeSaved);
        this.checkInitPracticeData(this.dataPractice);
      }
    },

    getBookInfo(isFirst = true) {
      let self = this;
      self.bookId && getInfoBookBasic(self.bookId).then(res => {
        if (res && res.data && !res.errors) {
          self.dataPractice = res.data;
          isFirst && self.checkInitPracticeData(res.data)
        }
      })
    },

    getBookDetailForActive() {
      this.acSetDataBookActiveWant({ ...this.dataPractice, name: this.dataPractice.bookName })
      setTimeout(() => {
        this.acToggleModalActiveBook(true)
      }, 200)
    },

    checkInitPracticeData(data) {
      if (data && data.limitPracticeX === 0 && !data.actived) {
        /*** Author: anhdd (8/7/2022) */
        //this.$router.push({ name:'exercise', query:{ lop: data.classId, mon: data.subjectId, tab: data.practiceTypeId} })
      } else if (data && this.loginPopupData && Object.keys(this.loginPopupData).length && ((this.pageCurr > data.limitPracticeX && !data.actived) || (data.limitPracticeY && this.pageCurr > data.limitPracticeY))) {
        this.pageCurr > data.limitPracticeX && !data.actived && this.getBookDetailForActive();
        // this.pageCurr > data.limitPracticeX && !data.actived && this.$bvModal.show('modal_active_book');
        data.limitPracticeY && this.pageCurr > data.limitPracticeY && data.actived && this.setToggleModalActivePage(true);
      }
    },

    handleToggleBookCats() {
      this.openBookCats = !this.openBookCats;
    },
    setCurrentQuestion(cat) {
      let dataCurrentQuestions = localStorage.getItem(LOCAL_SAVE_CURRENT_QUESTIONS) ? JSON.parse(localStorage.getItem(LOCAL_SAVE_CURRENT_QUESTIONS)) : []

      if (dataCurrentQuestions.length === 0) {
        dataCurrentQuestions.push({ email: this.authInfo.email, bookId: cat.bookId, bookIndexId: cat.bookIndexId })
      }
      else {
        let isUpdate = false
        for (let i = 0; i < dataCurrentQuestions.length; i++) {
          if (dataCurrentQuestions[i].bookId === parseInt(cat.bookId) && dataCurrentQuestions[i].email == this.authInfo.email) {
            dataCurrentQuestions[i].bookIndexId = cat.bookIndexId
            isUpdate = true
            break
          }
        }
        if (!isUpdate) {
          dataCurrentQuestions.push({ email: this.authInfo.email, bookId: cat.bookId, bookIndexId: cat.bookIndexId })
        }
      }
      localStorage.setItem(LOCAL_SAVE_CURRENT_QUESTIONS, JSON.stringify(dataCurrentQuestions))
    },
    openCollapse(id, cat) {
      this.setCurrentQuestion(cat)

      let self = this;
      if (this.isContainsEmailUnlimited(self.authInfo.email)) {
        self.catCurrent = cat;
        if (cat.bookIndexChilds.length > 0) {
          self.collapseOpen = self.collapseOpen === id ? '' : id;
          self.setCatDataCurr(cat);
        } else {
          // open all question of subject
          self.replaceRouter(cat.bookIndexId)
          // self.getQuestions(cat.bookIndexId, cat, true);
          if (self.screenWidth < 992) {
            self.openBookCats = false;
          }
        }
      }
      else {
        if ((self.dataPractice && cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived) || (self.dataPractice && self.dataPractice.limitPracticeY && cat.pageNo > self.dataPractice.limitPracticeY)) {
          if (self.authInfo && self.authInfo.email === self.emailPublic && cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived) {
            self.setToggleLoginForm(true);
          } else {
            // console.log(' vao truong hop else ben trong');
            // self.$bvModal.show('modal_active_book');
            // cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived && self.$bvModal.show('modal_active_book');
            cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived && self.getBookDetailForActive();
            self.dataPractice.limitPracticeY && cat.pageNo > self.dataPractice.limitPracticeY && self.dataPractice.actived && self.setToggleModalActivePage(true);
          }
        } else {
          if (self.dataPractice && cat.pageNo > self.dataPractice.limitPracticeY) {
            this.setToggleModalActivePage(true)
          } else {
            // cái else này giống cái else bị comment ở bên dưới 
            // self.questions = [];
            self.catCurrent = cat;
            if (cat.bookIndexChilds.length > 0) {
              self.collapseOpen = self.collapseOpen === id ? '' : id;
              self.setCatDataCurr(cat);
            } else {
              // open all question of subject
              self.replaceRouter(cat.bookIndexId)
              // self.getQuestions(cat.bookIndexId, cat, true);
              if (self.screenWidth < 992) {
                self.openBookCats = false;
              }
            }
          }

          // // self.questions = [];
          // self.catCurrent = cat;
          // if(cat.bookIndexChilds.length > 0) {
          //   self.collapseOpen = self.collapseOpen === id ? '' : id;
          //   self.setCatDataCurr(cat);
          // } else {
          //   // open all question of subject
          //   self.replaceRouter(cat.bookIndexId)
          //   // self.getQuestions(cat.bookIndexId, cat, true);
          //   if(self.screenWidth < 992) {
          //       self.openBookCats = false;
          //   }
          // }
        }
      }

    },

    getSubjects() {
      let self = this;
      // self.setLoading(true);
      if (self.bookId) {
        self.exerciseCats = []
        getCategoriesByBook(self.bookId).then(async res => {
          if (res && res.data && !res.errors) {
            self.exerciseCats = res.data;

            self.exerciseCats.map(value => {
              let countQuestion = 0;
              value.bookIndexChilds.map(elment => {
                countQuestion += elment.count;
                if (elment.bookIndexChilds.length > 0) {
                  elment.bookIndexChilds.map(item => {
                    countQuestion += item.count;
                  })
                }
              })
              value.countTotal = countQuestion;
            })
            self.catsFlat = await self.flatenCats(res.data)
            // Save bookIndex into state
            // self.actionBookIndexOfBook(resultFlatCat);
            let idCatCurr = parseInt(self.$route.query.danhmuc) || 0

            if (idCatCurr && idCatCurr > 0) {
              self.handleRouterReplace()
            } else {
              let catInfo = localStorage.getItem(LOCAL_SAVE_CAT);
              if (catInfo && catInfo !== null && catInfo !== undefined) {
                self.catCurrent = catInfo ? JSON.parse(catInfo) : {};
                let idCatCurr = self.$route.query.danhmuc ? parseInt(self.$route.query.danhmuc) : self.catCurrent.bookIndexId
                self.replaceRouter(self.catCurrent.bookIndexId)
              } else {
                // get list question
                // res.data.length > 0 && self.getQuestions(res.data[0].bookIndexId, res.data[0]);
                res.data.length > 0 && self.replaceRouter(res.data[0].bookIndexId)
                // res.data.length === 0 && self.setLoading(false);
              }
            }
            self.catsLength = self.catsFlat.length;
            // Save bookIndex into state
            self.actionBookIndexOfBook(self.catsFlat);
          }
        }).catch().finally();
      }
    },

    setScrollToCat() {
      let bookIndexIdCurr = this.$route.query.danhmuc
      let elem = document.getElementById(`cat_row_${bookIndexIdCurr}`);
      if (elem) {
        let topPos = elem.offsetTop;
        scrollTo(document.getElementById('book_viewer__cats'), topPos, 600);
      }
    },

    openSidebar(type) {
      if (type !== null) {
        type === 'info' && this.setResultQuestionForSidebarOfAccFree()
        this.typeOpenSidebar = { type, isOpen: type === this.keySidebarActive ? false : true }
        this.keySidebarActive = type !== this.keySidebarActive ? type : ''
      }
    },

    async getQuestions(bookIndexId, cat = {}, isClick = false) {
      console.log('auth')
      let self = this;
      // catsLength
      let lengthCatsFlat = self.catsFlat.length;
      let indexCatInFlat = self.catsFlat.findIndex(cat => cat.bookIndexId === bookIndexId);

      !self.dataPractice && await self.getInfoPracticeSaved();

      if (cat && cat.pageNo && self.dataPractice && self.authInfo && self.authInfo.email === self.emailPublic && cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived) {
        self.setToggleLoginForm(true);
      } else if (cat && cat.pageNo && self.dataPractice && ((cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived) || (self.dataPractice && self.dataPractice.limitPracticeY && cat.pageNo > self.dataPractice.limitPracticeY && self.dataPractice.actived))) {
        self.pageCurr = cat.pageNo;
        // if(self.authInfo && self.authInfo.email === self.emailPublic && cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived) {
        //     self.setToggleLoginForm(true);
        // } else {
        // cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived && self.$bvModal.show('modal_active_book');
        cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived && self.getBookDetailForActive();
        self.dataPractice.limitPracticeY && cat.pageNo > self.dataPractice.limitPracticeY && self.dataPractice.actived && self.setToggleModalActivePage(true);
        // }
      } else if (cat && cat.pageNo) { //&& self.dataPractice
        // self.setLoading(true);
        getQuestionsByCat(self.bookId, bookIndexId).then(res => {
          if (res && res.data && !res.errors) {
            self.questions = res.data;
            // let indexCat = self.catsFlat.findIndex(cat => cat.bookIndexId === bookIndexId);
            if (res.data.length > 0) {
              // let indexCat = self.catsFlat.findIndex(cat => cat.bookIndexId === res.data[0].bookIndexId);
              indexCatInFlat > -1 && self.setCatDataCurr(self.catsFlat[indexCatInFlat]);
              localStorage.setItem(LOCAL_QUESTIONS_DATA, JSON.stringify(res.data));
              // isClick && self.directExamQuestion(cat);
            } else {
              indexCatInFlat > -1 && indexCatInFlat <= lengthCatsFlat - 1 ? self.getQuestions(self.catsFlat[indexCatInFlat + 1].bookIndexId, self.catsFlat[indexCatInFlat + 1]) : self.getQuestions(self.catsFlat[0].bookIndexId, self.catsFlat[0])
            }
          }

        }).catch().finally();
      } else {
        if (indexCatInFlat > -1 && indexCatInFlat < lengthCatsFlat - 1) {
          self.getQuestions(self.catsFlat[indexCatInFlat + 1].bookIndexId, self.catsFlat[indexCatInFlat + 1])
        } else if (indexCatInFlat < lengthCatsFlat - 1) {
          self.getQuestions(self.catsFlat[0].bookIndexId, self.catsFlat[0])
        }
      }
    },

    setCatDataCurr(data) {
      let self = this;
      this.catCurrent = data;
      let indexCatInCatsFlat = self.catsFlat.findIndex(cat => cat.bookIndexId === data.bookIndexId);
      let dataCat = self.catsFlat[indexCatInCatsFlat];
      // let indexParent = indexCatInCatsFlat;

      if (self.firstloadData) {
        if (dataCat.catParentFirst && dataCat.catParent) {
          this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.catParentFirst}`);
          this.$root.$emit('bv::toggle::collapse', `cat_child_${dataCat.catParent}`);
        } else if (!dataCat.catParentFirst && dataCat.catParent) {
          this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.catParent}`)
        } else if (!dataCat.catParentFirst && !dataCat.catParent) {
          this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.bookIndexId}`);
        }
        self.firstloadData = false;
      } else {
        if (!dataCat.catParentFirst && dataCat.catParent && data.bookIndexChilds && data.bookIndexChilds.length) {
          this.$root.$emit('bv::toggle::collapse', `cat_child_${dataCat.bookIndexId}`);
        } else if (!dataCat.catParentFirst && !dataCat.catParent && data.bookIndexChilds && data.bookIndexChilds.length) {
          this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.bookIndexId}`);
        }
      }
    },

    goToCat(type = 0) {
      let indexCatCurr = this.catsFlat.findIndex(cat => cat.bookIndexId === parseInt(this.$route.query.danhmuc));
      if (indexCatCurr > -1) {
        let targetCat = type === 0 ? this.catsFlat[indexCatCurr - 1] : this.catsFlat[indexCatCurr + 1];
        if(type == 1){
          while(targetCat.bookIndexChilds.length>0){
            if(targetCat.catParent){
              if(!document.getElementById(`cat_child_${targetCat.bookIndexId}`).classList.contains('show')){
                this.openCollapse(`cat_child_${targetCat.bookIndexId}`, targetCat)
              }
            }
            else{
              if(!document.getElementById(`cat_${targetCat.bookIndexId}`).classList.contains('show')){
                this.openCollapse(`cat_${targetCat.bookIndexId}`, targetCat)
              }
            }
            if(type == 1){
              indexCatCurr++
            }
            else{
              indexCatCurr--
            }
            targetCat = type === 0 ? this.catsFlat[indexCatCurr - 1] : this.catsFlat[indexCatCurr + 1];
          }
        }
        else{
          while(targetCat.bookIndexChilds.length>0){
            if(type == 1){
              indexCatCurr++
            }
            else{
              indexCatCurr--
            }
            if(indexCatCurr - 1 < 0){
              return
            }
            targetCat = type === 0 ? this.catsFlat[indexCatCurr - 1] : this.catsFlat[indexCatCurr + 1];
          }
          let itemParent = targetCat
          let listParent = []
          while(itemParent.catParent){
            for(let i=0;i<this.catsFlat.length;i++){
              let item = this.catsFlat[i]
              if(item.bookIndexId == itemParent.catParent){
                itemParent = item
                break
              }
            }
            listParent.push(itemParent)
          }
          listParent.reverse();
          for(let i = 0; i<listParent.length;i++){
             let item = listParent[i]
            if(item.catParent){
              if(!document.getElementById(`cat_child_${item.bookIndexId}`).classList.contains('show')){
                this.openCollapse(`cat_child_${item.bookIndexId}`, item)
              }
            }
            else{
              if(!document.getElementById(`cat_${item.bookIndexId}`).classList.contains('show')){
                this.openCollapse(`cat_${item.bookIndexId}`, item)
              }
            }
          }
        }
        
        this.replaceRouter(targetCat.bookIndexId)
      }
    },

    handleActiveBookSuccess(val) {
      this.dataPractice.limitPracticeX = 1000;
      this.dataPractice.actived = true;
      this.getBookInfo();
    },

    handleActiveBook() {
      console.log('auth')
      if (this.authInfo && this.authInfo.email === this.emailPublic) {
        this.setToggleLoginForm(true);
      } else {
        this.getBookDetailForActive()
      }
    },

    getInfoSaveLocal() {
      let catInfo = localStorage.getItem(LOCAL_SAVE_CAT);
      let practiceData = localStorage.getItem(LOCAL_SAVE_EXERCISE_CLASS);
      let questionData = localStorage.getItem(LOCAL_QUESTIONS_DATA);

      if (questionData && questionData !== null && questionData !== undefined) {
        this.questionsSaved = JSON.parse(questionData);
      }

    },

    async getQuestionListSlider(bookIndexId) {
      console.log('auth')
      let self = this
      self.sliderQuestionList = []
      self.pagesOfQuestion = []
      let indexCatInFlat = self.catsFlat.findIndex(cat => cat.bookIndexId === bookIndexId);
      let cat = indexCatInFlat > -1 ? self.catsFlat[indexCatInFlat] : null

      !self.dataPractice && await self.getInfoPracticeSaved();
      if (cat && cat.pageNo && self.dataPractice && self.authInfo && self.authInfo.email === self.emailPublic && cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived && !this.isContainsEmailUnlimited(this.authInfo.email)) {
        self.setToggleLoginForm(true);
      } else if (cat && cat.pageNo && self.dataPractice && ((cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived) || (self.dataPractice.limitPracticeY && cat.pageNo > self.dataPractice.limitPracticeY && self.dataPractice.actived)) && !this.isContainsEmailUnlimited(this.authInfo.email)) {
        self.pageCurr = cat.pageNo;
        cat.pageNo > self.dataPractice.limitPracticeX && !self.dataPractice.actived && self.getBookDetailForActive();
        self.dataPractice.limitPracticeY && cat.pageNo > self.dataPractice.limitPracticeY && self.dataPractice.actived && self.setToggleModalActivePage(true)
      } else if (cat && cat.pageNo) { //&& self.dataPractice
        // self.setLoading(true)
        this.pageChange = cat.pageNo
        // console.log('cat', this.pageChange);
        this.actionCheckPage(this.pageChange)

        getQuestionsSidebar(bookIndexId).then(res => {
          let dataCurrentQuestions = localStorage.getItem(LOCAL_SAVE_CURRENT_QUESTIONS) ? JSON.parse(localStorage.getItem(LOCAL_SAVE_CURRENT_QUESTIONS)) : []
          self.sliderQuestionList = res && res.data && !res.errors ? res.data : [];
          if (res && res.data && res.data.length > 0) {
            self.getInfoQuestion();
            // Get question checked
            self.setQuestionResult();
            indexCatInFlat > -1 && self.setCatDataCurr(self.catsFlat[indexCatInFlat]);
            res.data.map(ques => {
              !self.pagesOfQuestion.includes(ques.pageNo) && self.pagesOfQuestion.push(ques.pageNo)
            })
            if (dataCurrentQuestions.length > 0 && this.firstSetCurrentDetail) {
              for (let i = 0; i < dataCurrentQuestions.length; i++) {
                if (dataCurrentQuestions[i].bookId == self.$route.query.sach && dataCurrentQuestions[i].email == this.authInfo.email) {
                  this.replaceRouter(dataCurrentQuestions[i].bookIndexId)
                  break
                }
              }
              this.firstSetCurrentDetail = false
            }
          } else {
            if (dataCurrentQuestions.length > 0 && this.firstSetCurrentDetail) {
              let isReplaceRouterLocalStorage = false
              for (let i = 0; i < dataCurrentQuestions.length; i++) {
                if (dataCurrentQuestions[i].bookId == self.$route.query.sach && dataCurrentQuestions[i].email == this.authInfo.email) {
                  isReplaceRouterLocalStorage = true
                  this.replaceRouter(dataCurrentQuestions[i].bookIndexId)
                  break
                }
              }
              if (!isReplaceRouterLocalStorage) {
                this.replaceRouter(bookIndexId)
              }
              this.firstSetCurrentDetail = false
            }
            else {
              this.replaceRouter(bookIndexId)
            }
            //indexCatInFlat > -1 && indexCatInFlat <= self.catsLength -1 ? self.replaceRouter(self.catsFlat[indexCatInFlat + 1].bookIndexId) : self.replaceRouter(self.catsFlat[0].bookIndexId)

          }
          this.actionSetBookIndexId(bookIndexId)
          this.actionSetBookIdForError(self.bookId)

        }).catch().finally();
      } else {
        if (indexCatInFlat > -1 && indexCatInFlat < self.catsLength - 1) {
          self.replaceRouter(self.catsFlat[indexCatInFlat + 1].bookIndexId)
        } else if (indexCatInFlat < self.catsLength - 1) {
          self.replaceRouter(self.catsFlat[0].bookIndexId)
        }
      }
    },

    getInfoQuestion() {
      let self = this;
      // self.question = null;
      // Hidden guide content
      self.showGuideContent = false;
      // self.arrResultCorrect = [];

      self.questionindexActive = self.$route.query.cauhoi;
      if (self.questionindexActive && self.questionindexActive > 0) {
        if (self.sliderQuestionList && self.sliderQuestionList.length > 0 && self.questionindexActive > self.sliderQuestionList.length) {
          // Replace for question 
          self.handleChangeQuestionDisplay()
          return
        }
        let questionId = self.sliderQuestionList[self.questionindexActive - 1] ? self.sliderQuestionList[self.questionindexActive - 1].questionId : 0;
        if (questionId > 0) {
          let questionsLocalStorage = localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED) && localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED) !== null ? JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED)) : null;

          if (questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
            let indexQuestionSave = questionsLocalStorage.findIndex(ques => ques.questionId === questionId);
            if (indexQuestionSave > -1) {
              self.question = questionsLocalStorage[indexQuestionSave];
            } else {
              self.getQuestionDetail(questionId, questionsLocalStorage);
            }
          } else {
            self.getQuestionDetail(questionId);

          }
        }
      } else {
        let queryCat = self.$route.query.danhmuc ? parseInt(self.$route.query.danhmuc) : 0
        if (queryCat && queryCat > 0 && self.dataPractice && self.dataPractice.lastBookIndexId && self.dataPractice.lastQuestionId && self.sliderQuestionList) {
          let indexQuestion = self.sliderQuestionList.findIndex(que => que.questionId === self.dataPractice.lastQuestionId)
          indexQuestion > -1 && self.replaceRouter(queryCat, indexQuestion + 1)
        }
      }
    },

    getQuestionDetail(questionId, dataQuestion = []) {
      let self = this;
      self.pagesOfQuestion = []
      self.question = {}
      // Get question detail
      getQuestionDetail(questionId).then(res => {
        if (res && res.data && !res.errors) {
          let typeQuestion = res.data.type === TYPE_GROUP ? 'group' : 'single'
          let questionContentReplace = setContentMediaEditorShow({ ...res.data }, typeQuestion)
          self.actionSetPageNoBook(res.data.pageNo)

          self.question = questionContentReplace;
          let dataSave = dataQuestion.length === 0 ? [questionContentReplace] : [...dataQuestion, questionContentReplace];
          self.saveLocalQuestion(dataSave);
          self.pagesOfQuestion = res.data.pageNo ? [res.data.pageNo] : []
          // console.log('h9h9h9h', res.data.pageNo);
          // this.pageChange = res.data.pageNo
        }
      }).catch().finally();
    },

    saveLocalQuestion(data) {
      let dataSave = JSON.stringify(data);
      localStorage.setItem(LOCAL_SAVE_QUESTIONS_WORKED, dataSave);
    },

    setQuestionResult() {
      let self = this;
      let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED));
      if (questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
        questionsLocalStorage.map((ques, index) => {
          if (ques.statusWorked) {
            let resultCheckAnswer = ques.workedFail ? 'error' : 'success';
            let indexQuestionInList = self.sliderQuestionList.findIndex(queList => queList.questionId === ques.questionId);
            if (indexQuestionInList > -1) {
              self.sliderQuestionList[indexQuestionInList].answerStatus = resultCheckAnswer;
              self.logQuestionWorked(resultCheckAnswer);
            }
          }
        })
      }
    },

    logQuestionWorked(status) {
      this.question['isTrue'] = status === 'success'
      this.question['isWorked'] = true;
    },

    async checkAnswer() {
      console.log('checkAnswer')
      let self = this;
      self.resetValKeyboard()

      if (self.question.type !== TYPE_DOWN_ANSWER) {
        self.setQuestionList4CheckAnswer([{ ...self.question }])
        self.setQuestionData4CheckAnswer({ ...self.question })
      }

      if (self.question.type === TYPE_GROUP) {
        self.txtMissingQuestionGroup = '';
        self.setQuestionData4CheckAnswer({ ...self.question, isGroup: true, parent: parent.questionId })
      }

      if (self.question.type !== TYPE_DOWN_ANSWER) {
        await self.setActionCheckQuestion(true);
      } else {
        self.question = { ...self.question, isTrue: true }
        self.saveQuestion2Local(self.question)
      }
      self.showGuideContent = true;

      if (self.question.isTrue) {
        self.setResultQuestionsSlider(true)
        self.actionPlayQuestionTrue = true;
        setTimeout(() => {
          document.getElementById('question_true').play();
        }, 5)
      } else {
        // self.actionCheckExcercise({isCheck: true})
        self.setResultQuestionsSlider(false)
        self.actionPlayQuestionFalse = true;
        setTimeout(() => {
          document.getElementById('question_false').play();
        }, 5)
      }
      // Active answer correct tab = 1
      // this.tabGuideActive = 1;
      // Update state for question:
      // await self.question.type === TYPE_GROUP && this.setQuestionResult();
      // if ( self.question.type === TYPE_GROUP ) {
      //     self.setResultForQuestionChild()
      // }
      // await self.question.type === TYPE_GROUP && self.setResultForQuestionChild() 
      // self.authInfo && self.authInfo.email !== EMAIL_PUBLIC && saveUserWorkQuestion(self.question).then(res => self.questionIdCheckAnswer = self.question.questionId)
      let timeCal = callTimeDiff(this.startTimeQuestion)
      self.authInfo && self.authInfo.email !== EMAIL_PUBLIC && saveUserWorkQuestion(self.question, timeCal.minute)
      setTimeout(() => {
        self.actionPlayQuestionTrue = false;
        self.actionPlayQuestionFalse = false;
      }, 4000)
    },

    saveQuestion2Local(questionCurr) {
      let questionsLocalStorage = localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED)
      if (!questionsLocalStorage || questionsLocalStorage === null || questionsLocalStorage === undefined) {
        this.saveLocalQuestion([questionCurr])
        return
      }

      questionsLocalStorage = JSON.parse(questionsLocalStorage)
      if (questionsLocalStorage.length === 0) {
        this.saveLocalQuestion([questionCurr])
        return
      }

      const indexQuestionInList = questionsLocalStorage.findIndex(ques => ques.questionId === questionCurr.questionId)
      if (indexQuestionInList > -1) {
        questionsLocalStorage[indexQuestionInList] = { ...questionCurr }
        this.saveLocalQuestion(questionsLocalStorage)
      }
    },

    handleAnswerMissing(valErr) {
      if (this.question.type === TYPE_GROUP) {
        this.txtMissingQuestionGroup = valErr;
      }
      setTimeout(() => {
        this.showGuideContent = false;
      }, 5)
    },

    toggleGuideContent() {
      this.showGuideContent = !this.showGuideContent;
    },

    setResultQuestionsSlider(value = true) {
      if (this.questionindexActive > 0) {
        this.sliderQuestionList[this.questionindexActive - 1]['isWorked'] = true
        this.sliderQuestionList[this.questionindexActive - 1]['isTrue'] = value
      }
      if (this.authInfo && this.authInfo.email === EMAIL_PUBLIC && this.sliderQuestionList.length > 0) {
        this.setResultQuestionForSidebarOfAccFree()
      } else if (this.keySidebarActive === 'info') {
        this.questionIdCheckAnswer = { value, id: this.sliderQuestionList[this.questionindexActive - 1].questionId }
      }
    },

    async setResultQuestionForSidebarOfAccFree() {
      let questionCorrect = 0
      let questionInCorrect = 0
      let questionNotDone = 0
      await this.sliderQuestionList.map(ques => {
        if (ques.isWorked && ques.isTrue) {
          questionCorrect += 1
        } else if (ques.isWorked && !ques.isTrue) {
          questionInCorrect += 1
        } else {
          questionNotDone += 1
        }
      })

      this.questionIdCheckAnswer = { ...this.questionIdCheckAnswer, questionCorrect, questionInCorrect, questionNotDone }
    },

    async resetAnswers() {
      let self = this;
      // self.actionCheckExcercise({isCheck: false})
      resetResultWorkQuestion(self.question.questionId).then(res => {
        if (res && !res.errors) {
          this.formatAllQuestion()
          this.startTimeQuestion = new Date()
        }
      })
    },

    resetQuestionsList() {
      resetUserWorkQuestionByBookIndexId(parseInt(this.$route.query.danhmuc)).then(res => {
        if (res && !res.errors) {
          this.$toast.success('Thực hiện làm lại bài tập thành công!')
          this.$bvModal.hide(this.idModalConfirmDelQuestion)
          this.formatAllQuestion()
          this.startTimeQuestion = new Date()
        }
      })
    },

    formatAllQuestion() {
      localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
      this.question = {}
      this.sliderQuestionList = []
      // this.questionIdCheckAnswer = 0
      if (this.keySidebarActive === 'info') {
        this.questionIdCheckAnswer = {
          value: this.sliderQuestionList && this.sliderQuestionList[this.questionindexActive - 1] && this.sliderQuestionList[this.questionindexActive - 1].isTrue ? true : false,
          id: 0
        }
      }
      // Get question info
      Promise.all([this.getInfoQuestion(), this.getQuestionListSlider(parseInt(this.$route.query.danhmuc))]);
    },

    handleCheckAnswerResult() {
      if (this.question.type === TYPE_GROUP) {
        this.txtMissingQuestionGroup = '';
      }
      (this.question.type !== this.typeDrawShape && this.question.type !== this.typeDownAnswer) && this.checkAnswer();
    },

    resetValKeyboard() {
      this.valVituralKeyboard && this.setVituralKeyVal({});
    },

    handleOffModal() {
      this.setDocPreviewSlider({});
      this.setToggleModalDocSlider(false);
    },

    viewMoreMedia(val) {
      this.mediaRelate = val
    },

    handleRouterReplace() {
      let self = this
      let catCurr = parseInt(self.$route.query.danhmuc)
      if (catCurr && catCurr > 0) {
        self.getQuestionListSlider(parseInt(catCurr))
        setTimeout(() => {
          self.setScrollToCat()
        }, 500)
      }
    },

    replaceRouter(cat, question = 1, isSetCurrentQuestion = false) {
      this.$router.replace({ query: { ...this.$route.query, danhmuc: cat, cauhoi: question } })
      this.startTimeQuestion = new Date()
      if(isSetCurrentQuestion){
        this.setCurrentQuestion({bookId: this.$route.query.sach, bookIndexId: cat })
      }
    },

    openModalNotiErrorQuestion() {
      this.acToggleModaShowError({ isShow: true, errorTypeId: this.errorTypeId })
    },

    handleChangeQuestionDisplay() {
      this.question = {}
      let questionPosition = this.$route.query.cauhoi ? parseInt(this.$route.query.cauhoi) : 1
      if (this.sliderQuestionList && this.sliderQuestionList.length > 0 && questionPosition > this.sliderQuestionList.length) {
        let indexQuestionInQuery = this.sliderQuestionList.findIndex(ques => ques.questionId === questionPosition)
        let quetionPositon = indexQuestionInQuery > -1 ? indexQuestionInQuery + 1 : 1
        this.replaceRouter(parseInt(this.$route.query.danhmuc), quetionPositon)
      } else {
        this.getInfoQuestion()
      }
    },

    checkLimitExercise(bookIndexId) {
      let catCurr = bookIndexId ? bookIndexId : this.$route.query.danhmuc ? parseInt(this.$route.query.danhmuc) : 0
      let indexCatInFlat = this.catsFlat.findIndex(cat => cat.bookIndexId === catCurr);
      let cat = indexCatInFlat > -1 ? this.catsFlat[bookIndexId ? indexCatInFlat : indexCatInFlat + 1] : null
      if (cat && cat.pageNo && this.dataPractice && this.authInfo && this.authInfo.email === this.emailPublic && cat.pageNo > this.dataPractice.limitPracticeX && !this.dataPractice.actived) {
        this.setToggleLoginForm(true);
        return false
      } else if (cat && cat.pageNo && this.dataPractice && ((cat.pageNo > this.dataPractice.limitPracticeX && !this.dataPractice.actived) || (this.dataPractice.limitPracticeY && cat.pageNo > this.dataPractice.limitPracticeY && this.dataPractice.actived))) {
        this.pageCurr = cat.pageNo;
        cat.pageNo > this.dataPractice.limitPracticeX && !this.dataPractice.actived && this.getBookDetailForActive();
        this.dataPractice.limitPracticeY && cat.pageNo > this.dataPractice.limitPracticeY && this.dataPractice.actived && this.setToggleModalActivePage(true)
        return false
      } else if (cat && cat.pageNo) {
        return true
      }
    },

    prevCatBook() {
      this.resetValKeyboard();
      this.question = {}
      this.handleNextPrevCat = 'prev'
      this.goToCat()
    },

    nextCatBook() {
      this.resetValKeyboard();
      this.question = {}
      this.handleNextPrevCat = 'next'
      if (this.checkLimitExercise()) {
        this.goToCat(1)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins";
@import "@/assets/scss/_variables";
@import "@/assets/scss/_general";

.check--icon {
  display: none;

  @media screen and (max-width:575px) {
    display: block;
  }
}

.check--text {
  display: block;

  @media screen and (max-width:575px) {
    display: none;
  }
}

.btn-main {
  @media screen and (max-width: 575px) {
    background: none !important;
    border: none !important;
  }
}

.content-left {
  width: 90%;

  .text-a {
    width: 135px;

    @media screen and (max-width: 575px) {
      width: auto;
      padding: 5px 15px;
    }
  }

  .book--name {
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.content-right {
  width: 10%;
  padding-top: 5px;
}

.book-viewer__cats__books {
  margin-bottom: 40px;

  @media screen and (max-width: 575px) {
    margin-bottom: 25px;
  }
}

.actived {
  color: #0f3dba !important;
}

.activeUnLogin {
  color: #0f3dba !important;
}

.bookActive {
  color: #0f3dba !important;
}

.version {
  margin-right: 15px;
}

.icon-help {
  position: absolute;
  right: 15px;
}

.exercise-detail {
  &__swiper {
    .question-name__prev {
      display: none !important;
    }
  }

  &__questions {
    padding: 30px;
  }

  &__breadcrumb {
    padding-left: 15px;
    padding-right: 15px;

    ul li {

      @media screen and (min-width: 576px) and (max-width: 991px) {
        width: 15%;
      }

      @media screen and (max-width: 575px) {
        width: 25%;
      }

      a,
      span,
      &:before {
        @media screen and (min-width: 992px) and (max-width: 1199px) {
          font-size: 14px;
        }

        @media screen and (min-width: 576px) and (max-width: 991px) {
          font-size: 12px;
        }

        @media screen and (max-width: 575px) {
          font-size: 11px;
        }
      }

    }
  }

  &__link {
    margin-bottom: 30px;

    button {
      line-height: 1;
      padding: 0 20px;
    }
  }

  &__list,
  &__feedback {
    margin-bottom: 20px;
  }
}

.book-viewer__cats .card-body ul li:not(:last-child) {
  margin-bottom: 12px;
}

.cat-head,
.cat-child li {
  @extend .display-flex;
  @extend .justify-content-between;

  >i {
    @extend .position-rel;
    top: 5px;
    @extend .font-size-20;
  }
}

.modal-confirm {
  padding: 20px 15px;

  p {
    margin-bottom: 15px;
  }

  &__action {
    >* {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .exercise-detail {

    &__questions {
      padding: 15px;
    }
  }
}

@media screen and (max-width: 575px) {
  .btn-min-w-mb {
    min-width: 80px !important;
    line-height: 18px;
  }
}

@media screen and (max-width: 375px) {
  .btn-min-w-mb {
    font-size: 14px !important;
  }
}
</style>